import { useState } from 'react';
import { Button } from '@/components/ui';
import type { AdminClient } from './types';
import { namesMatch } from '@/lib/confirmName';


export function DeleteClientModal({
  client, busy, error, onCancel, onConfirm,
}: {
  client: AdminClient;
  busy: boolean;
  /** Why the last attempt failed. Without this the modal closed into nothing. */
  error?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const [typed, setTyped] = useState('');
  // Typographic quotes, case and spacing do not count — a keyboard cannot
  // produce the curly quote a pasted name may carry, and the safeguard is
  // "did you type this client's name", not "did you reproduce its bytes".
  const armed = namesMatch(typed, client.name) && !busy;
  return (
    <div className="admin-modal" role="dialog" aria-modal="true">
      <div className="admin-modal__scrim" onClick={busy ? undefined : onCancel} />
      <div className="admin-modal__panel">
        <div className="admin-modal__head">
          <div>
            <h3>Delete {client.name}?</h3>
            <p className="dash-muted">This permanently removes the client from the portal.</p>
          </div>
        </div>
        <p className="dash-muted" style={{ marginBottom: 10 }}>This will delete, and cannot be undone:</p>
        <ul className="admin-del__list">
          <li>The client organization and <strong>all its user access</strong></li>
          <li><strong>{client.leadCount.toLocaleString()}</strong> lead{client.leadCount === 1 ? '' : 's'} and their CRM status/values</li>
          <li>All content interviews, drafts, and uploaded photos</li>
          <li>Campaign metrics, AI recommendations, and analytics cache</li>
          <li>Its data-source connections (BigQuery, Google Ads, GA4) — sync stops</li>
        </ul>
        <label className="admin-del__confirm">
          <span>Type <strong>{client.name}</strong> to confirm</span>
          <input
            className="tr-input"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={client.name}
            autoFocus
          />
        </label>
        {error && <p className="admin-modal__err" style={{ margin: '0 0 12px' }}>{error}</p>}
        <div className="admin-del__actions">
          <button className="cq-cancel" onClick={onCancel} disabled={busy}>Cancel</button>
          <Button variant="danger" size="sm" disabled={!armed} onClick={onConfirm}>
            {busy ? 'Deleting…' : 'Delete permanently'}
          </Button>
        </div>
      </div>
    </div>
  );
}
